/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuCategoryDto as DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuCategories/menu-category-dto';
import { UpdateMenuCategoryDto as DigiworkMaitreDPosDtoMenuCategoriesUpdateMenuCategoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuCategories/update-menu-category-dto';

export interface UpdateMenuCategory$Params {
  menuCategoryId: string;
      body?: DigiworkMaitreDPosDtoMenuCategoriesUpdateMenuCategoryDto
}

export function updateMenuCategory(http: HttpClient, rootUrl: string, params: UpdateMenuCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, updateMenuCategory.PATH, 'put');
  if (params) {
    rb.path('menuCategoryId', params.menuCategoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>;
    })
  );
}

updateMenuCategory.PATH = '/api/menu-categories/{menuCategoryId}';
